import type { FC, SVGProps } from "react";

const IconFreeExperiences: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M3.5 7.00004L14.08 1.94004C14.1999 1.88263 14.3301 1.84972 14.4629 1.84323C14.5957 1.83674 14.7285 1.85681 14.8535 1.90225C14.9784 1.94769 15.0931 2.01759 15.1907 2.10788C15.2883 2.19816 15.367 2.307 15.422 2.42804L17.5 7.00004" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 9V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 13V14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 18V20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 7H3C1.89543 7 1 7.89543 1 9V18C1 19.1046 1.89543 20 3 20H19C20.1046 20 21 19.1046 21 18V9C21 7.89543 20.1046 7 19 7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFreeExperiences;